import { create } from "zustand";

interface NavigationHistoryState {
  previousPathname: string | null;
  currentPathname: string | null;
  recordNavigation: (
    previousPathname: string | null,
    currentPathname: string,
  ) => void;
  reset: () => void;
}

export const useNavigationHistoryStore = create<NavigationHistoryState>(
  (set) => ({
    previousPathname: null,
    currentPathname: null,
    recordNavigation: (previousPathname, currentPathname) =>
      set((state) =>
        state.currentPathname === currentPathname
          ? state
          : { previousPathname, currentPathname },
      ),
    reset: () => set({ previousPathname: null, currentPathname: null }),
  }),
);

export const usePreviousPathname = (): string | null =>
  useNavigationHistoryStore((s) => s.previousPathname);
